import { Input } from '@/components/ui/input';
import { cn } from '@/lib/utils';
import type { ReactNode } from 'react';

export const InputWithIcon = ({
  icon,
  value,
  onChange,
  placeholder,
  type = 'text',
  className,
  inputClassName,
  suffix,
  ...props
}: {
  icon: ReactNode;
  value?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
  type?: string;
  className?: string;
  inputClassName?: string;
  suffix?: string;
} & Omit<React.ComponentProps<typeof Input>, 'onChange'>) => {
  return (
    <div
      className={cn(
        'flex items-center gap-2 p-1 h-fit text-xs rounded-md bg-transparent border border-transparent hover:bg-secondary focus-within:bg-secondary transition-colors',
        className,
      )}
    >
      <div className="flex-shrink-0">{icon}</div>
      <Input
        type={type}
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        placeholder={placeholder}
        className={cn(
          'border-0 bg-transparent text-xs  text-gray-600 focus-visible:ring-0 focus-visible:border-0 p-0 h-auto',
          inputClassName,
        )}
        {...props}
      />
      {suffix && (
        <span className="text-xs  text-gray-600 flex-shrink-0">{suffix}</span>
      )}
    </div>
  );
};
